// Inline platform glyphs, recreated from the design handoff's DC logic class.
// `fill="currentColor"` so callers control the color via CSS.

export function AppleGlyph({ size = 30 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M16.4 12.7c0-2 1.6-3 1.7-3-.9-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7-.6 0-1.6-.7-2.6-.7-1.3 0-2.6.8-3.2 2-1.4 2.4-.4 6 1 8 .7 1 1.4 2.1 2.4 2 1 0 1.3-.6 2.5-.6s1.5.6 2.5.6 1.7-1 2.3-2c.7-1.1 1-2.2 1-2.3 0 0-2-.8-2.1-3.1z" />
      <path d="M14.5 5.6c.5-.7.9-1.6.8-2.6-.8 0-1.7.5-2.3 1.2-.5.6-.9 1.5-.8 2.4.9.1 1.8-.4 2.3-1z" />
    </svg>
  );
}

export function WindowsGlyph({ size = 28 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z" />
    </svg>
  );
}

export function AndroidGlyph({ size = 26 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M5 4l14 8-14 8V4z" />
    </svg>
  );
}

const GLYPHS = { apple: AppleGlyph, windows: WindowsGlyph, android: AndroidGlyph };

// Resolve a glyph by key (used by download cards driven by data.js).
export function PlatformGlyph({ name, size }) {
  const Glyph = GLYPHS[name] || AppleGlyph;
  return <Glyph size={size} />;
}
